import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type8TimestampUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type8Timestamp", configService);
    }
}
